import type { FeedHealth } from "../../types/index.ts";

export type FeedHealthFilter = "dashboard" | "all" | "healthy" | "failing" | "quiet" | "disabled";
export interface TimeRangeOption { value: number; label: string }

const DEFAULT_RANGES: TimeRangeOption[] = [
  { value: 6, label: "6 hours" },
  { value: 12, label: "12 hours" },
  { value: 24, label: "24 hours" },
  { value: 72, label: "3 days" },
  { value: 168, label: "7 days" },
  { value: 0, label: "All time" },
];
const SPORTS_RANGES: TimeRangeOption[] = [
  { value: 48, label: "2 days" },
  { value: 72, label: "3 days" },
  { value: 168, label: "7 days" },
  { value: 720, label: "30 days" },
  { value: 0, label: "All time" },
];
const NICHE_RANGES: TimeRangeOption[] = [
  { value: 168, label: "7 days" },
  { value: 336, label: "14 days" },
  { value: 720, label: "30 days" },
  { value: 0, label: "All time" },
];

const isFailing = (feed: FeedHealth) => feed.enabled && feed.error_count > 0;
const isQuiet = (feed: FeedHealth) => feed.enabled && feed.error_count === 0 && feed.articles_last_24h === 0;

export function getFeedHealthSummary(feeds: FeedHealth[]) {
  return {
    enabled: feeds.filter((feed) => feed.enabled).length,
    failing: feeds.filter(isFailing).length,
    quiet: feeds.filter(isQuiet).length,
  };
}

export function filterFeedHealth(feeds: FeedHealth[], filter: FeedHealthFilter, search: string) {
  const query = search.trim().toLowerCase();
  return feeds.filter((feed) => {
    const matchesSearch = !query || feed.name.toLowerCase().includes(query);
    const matchesFilter =
      filter === "all" ||
      (filter === "dashboard" && (isFailing(feed) || isQuiet(feed))) ||
      (filter === "failing" && isFailing(feed)) ||
      (filter === "quiet" && isQuiet(feed)) ||
      (filter === "disabled" && !feed.enabled) ||
      (filter === "healthy" && feed.enabled && !isFailing(feed) && !isQuiet(feed));
    return matchesSearch && matchesFilter;
  });
}

export function getTimeRangeOptions(feedGroup: string | null): TimeRangeOption[] {
  if (feedGroup === "sports") return SPORTS_RANGES;
  if (feedGroup === "poker" || feedGroup === "gambling") return NICHE_RANGES;
  return DEFAULT_RANGES;
}

export function defaultHoursForFeedGroup(feedGroup: string | null): number {
  if (feedGroup === "sports") return 48;
  if (feedGroup === "poker" || feedGroup === "gambling") return 168;
  return 24;
}
